export default "__VITE_ASSET__6fc76e97__"